import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TransactionHistoryModel, TxnHistoryModel } from '@app/models/customer-transaction-history/TransactionHistoryModel';
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { TransactionHistoryService } from '@app/services/transactionHistory/transactionHistory.service';
import { TransactionType, UserCategory } from '@app/common/app-enum';
import { AccountInfoService } from '@app/services/account-info/account-info.service';
import { AccountInfoModelList, AccountInfoModel } from '@app/models/account-info/myAccountInfoModel';
//import { TransactionFilterModel } from '@app/models/Transaction-Filter-model';
import { ProfileDetailsService } from '@app/services/customerProfile/profile-details.service';
import { ProfileDetialsModel } from '@app/models/ProfileDetailsModel';
import { TransactionFilterModel } from '@app/models/customer-transaction-history/Transaction-Filter-model';

@Component({
  selector: 'app-customer-transaction-history',
  templateUrl: './customer-transaction-history.component.html',
})
export class CustomerTransactionHistoryComponent implements OnInit {
  category: string = UserCategory.Corporate;
  categoryid: string;
  transactionDetailByMonths = [];
  IsDashboardCall: boolean = true;
  transactionDetail = [];
  txnFilterModel = new TransactionFilterModel();
  profileDetails: ProfileDetialsModel = new ProfileDetialsModel();
  tempTxnHistory = new Array<TxnHistoryModel>();
  getAccountInfo: AccountInfoModel = new AccountInfoModel();
  customerName: string = '';
  startDate: string = '';
  endDate: string = '';
  cardAmt: number;
  bankPgAmt: number;
  NEFTAmt: number;
  CCMSAmt: number;
  CardBalAmt: number;
  tempCCMS: number;
  tempCount: number;
  pageNumber: number = 1;
  offset = 0;
  limit: number = 10;
  data: Array<any>;
  totalCount: number = 0;
  paginatedData: Array<any>;
  errorMessageDate: string = '';

  transactionHistory = new TransactionHistoryModel();
  allAccountInfoList: AccountInfoModelList[] = new Array<AccountInfoModelList>();
  toCard: number;
  toCCMS: number;
  cardCredit: number;
  cardDebit: number;

  @Output() countTransactions: EventEmitter<number> = new EventEmitter<number>();
  @Input() isDashBoardCall: boolean;
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private transactionhistoryService: TransactionHistoryService, private accountInfoService: AccountInfoService, private profileDetailsService: ProfileDetailsService, private toastyService: ToastrService) {
  }
  ngOnInit() {
    this.categoryid = localStorage.getItem('Category');
    this.toCard = TransactionType.CCMSToCard;
    this.toCCMS = TransactionType.CardToCCMS;
    this.cardCredit = TransactionType.CardCredit;
    this.cardDebit = TransactionType.CardDebit;
    this.getCardNumberTransation();
    this.getUserDetails();
    this.setDate();
    this.filterTransaction();
    this.bindMyAccountList(this.IsDashboardCall);
  }

  getTransactionHistory(txnFilterModel) {
      this.txnFilterModel.IsDashBoardCall = this.isDashBoardCall;
      this.transactionhistoryService.getTransactionHistory(txnFilterModel).subscribe(data => {
      this.transactionHistory = JSON.parse(JSON.stringify(data));
      this.data = JSON.parse(JSON.stringify(data));
      this.cardAmt = this.transactionHistory.CardSaleAmt;
      this.bankPgAmt = this.transactionHistory.BankPgLoadAmt;
      this.NEFTAmt = this.transactionHistory.NEFTRTGSLoadAmt;
      this.CCMSAmt = this.transactionHistory.CCMSSaleAmt;
      this.CardBalAmt = this.transactionHistory.CardBalanceAmt;
      this.getCount();
      this.tempCount = this.transactionHistory.Count;
      this.startDate = this.txnFilterModel.StartDate.toDateString();
      this.endDate = this.txnFilterModel.EndDate.toDateString();
      this.groupTransactionHistoryByYearAndMonth();
      
    });
  }

  getCount() {
    this.countTransactions.emit(this.transactionHistory.Count);
  }
  groupTransactionHistoryByYearAndMonth() {
    const groupedObj = this.transactionHistory.TxnHistory.reduce((prev, current) => {
      var transactionYearAndMonth = current["TransactionDateOnly"];
      //current["TransactionDateOnly"].substring(0, 8); //Getting only year and month

      if (!prev[transactionYearAndMonth]) {
        prev[transactionYearAndMonth] = [current];
      } else {
        prev[transactionYearAndMonth].push(current);
      }
      return prev;

    }, {});
    this.transactionDetailByMonths = Object.keys(groupedObj)
      .map(transactionDateAndMonth => ({
        transactionDateAndMonth, transactionDetail: groupedObj[transactionDateAndMonth]
      }));
  }

  getCardNumberTransation() {
    this.accountInfoService.getCardNumber()
      .subscribe(data => {
        this.allAccountInfoList = JSON.parse(JSON.stringify(data));
        for (let a of this.allAccountInfoList) {
          this.txnFilterModel.CardNumber = a.CardNumber;
        }
        this.txnFilterModel.CardNumber = '0';
      });
  }

  bindMyAccountList(IsDashboardCall) {
    this.accountInfoService.getAccountInfo(IsDashboardCall).subscribe(data => {
      this.getAccountInfo = JSON.parse(JSON.stringify(data));
      this.tempCCMS = this.getAccountInfo.CCMSBalance;
    });
  }

  getTotalRecord = () => {
    // debugger;
    return this.transactionhistoryService.getTransactionReportPdfExcel(this.txnFilterModel)
      .map(a => JSON.parse(JSON.stringify(a)).TxnHistory.map(b => {
        return {
          'Txn Date': JSON.parse(JSON.stringify(b)).TransactionDate,
          'Outlet Name': JSON.parse(JSON.stringify(b)).OutletName,
          'Card Number': JSON.parse(JSON.stringify(b)).CardNumber,
          'Vehicle No.': JSON.parse(JSON.stringify(b)).VehicleRegistrationNo,
          'Txn Type': JSON.parse(JSON.stringify(b)).TransactionType,
          'Txn Id': JSON.parse(JSON.stringify(b)).TransactionId,
          'Amount': JSON.parse(JSON.stringify(b)).TxnAmount,
          'Quantity': JSON.parse(JSON.stringify(b)).CNGQuantity,
        };
      }));
  }

  filterTransaction() {
    this.pageNumber = 1;
    this.txnFilterModel.SkipCount = 0;
    if (this.txnFilterModel.StartDate <= this.txnFilterModel.EndDate) {
      this.getTransactionHistory(this.txnFilterModel);
      this.errorMessageDate = '';
    }
    else {
      this.errorMessageDate = 'End date should be greater then Start date.';
    }
  }

  getUserDetails() {
    this.profileDetailsService.getUserData().subscribe(data => {
      this.profileDetails = JSON.parse(JSON.stringify(data));
      this.customerName = this.profileDetails.FirstName;
    });
  }

  setDate() {
    var date = new Date();
    this.txnFilterModel.StartDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.txnFilterModel.EndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  pageControl(event: number, sortName: string) {
    this.pageNumber = event;
    this.bindPaginationDate(10 * (this.pageNumber - 1));
  }
  bindPaginationDate(offset: number) {
    this.txnFilterModel.SkipCount = offset;
    this.getTransactionHistory(this.txnFilterModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/customer-reports/customer-transaction-history/customer-transaction-history.component.ts